import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const AcePrints = () => {

  const  servicesFaqData = [
    { 
        question: "What types of materials can Printingy print for architecture and construction projects?", 
        answer: "Printingy offers a variety of materials for Architecture and construction Printing, including durable paper, vinyl, and specialised media for printing construction plans and blueprints. For 3D printing in construction and architecture, we use high-quality filaments to produce detailed and accurate models. These materials ensure your prints are functional and visually precise, supporting your project’s needs."
    },
    { 
        question: "Does Printingy handle bulk orders for architecture and construction prints?", 
        answer: "Yes, Printingy specialises in bulk printing of architecture plans, construction plans, and blueprints. Bulk printing ensures consistent quality and cost-effective solutions for large-scale projects. Our efficient production processes and advanced technology guarantee reliable results and timely delivery for all bulk orders."
    },
    { 
        question: "What industries benefit from architecture and construction printing services?", 
        answer: "Our Architecture and construction Printing services cater to industries such as architecture, engineering, construction, and urban planning. Professionals rely on us for blueprint printing, printing construction plans, and 3D model production to support the design, planning, and execution phases. Printingy provides tailored solutions to meet these industries' unique requirements."
    },
    { 
        question: "Does Printingy provide 3D printing services for architecture and construction?", 
        answer: "We offer 3D printing for construction and architecture projects, producing detailed models and prototypes. Our 3D printing services enable architects and engineers to visualise designs, identify potential challenges, and present concepts effectively. These models are crafted with precision to ensure they meet your exact specifications."
    },
    { 
        question: "What is the typical turnaround time for architecture and construction printing?", 
        answer: "Turnaround times for Architecture & Construction Printing depend on the size and complexity of the project. Standard orders for blueprint printing or printing construction plans are typically completed within a few business days. For larger volumes or highly customised 3D models, we provide clear timelines and prioritise meeting your deadlines."
    },
    { 
        question: "What customisation options are available for architecture and construction prints?", 
        answer: "Printingy provides extensive customisation options for printing architecture plans and related materials. You can select paper sizes, media types, and finishing options to meet your project’s needs. For 3D printing for construction and architecture, we offer a range of filaments and design adjustments to ensure the model meets your specifications."
    },
    { 
        question: "Are eco-friendly options available for architecture and construction printing?", 
        answer: "Yes, Printingy is committed to sustainability and offers eco-friendly options for printing construction plans and blueprints. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for professionals seeking environmentally responsible printing solutions."
    },
    { 
        question: "What factors should I consider when ordering architecture and construction prints?", 
        answer: "When ordering Architecture & Construction Printing, consider the materials' purpose, audience, and application. Selecting the right paper type, size, and level of detail ensures your plans and models are effective and visually precise. Printingy’s team guides to help you achieve the best results for your project."
    },
    { 
        question: "How do I place an order for architecture and construction printing services?", 
        answer: "Placing an order is simple and efficient. Visit our website to select your preferences for printing architecture plans, construction plans, or blueprints. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk architecture and construction printing cost-effective?", 
        answer: "Bulk printing reduces per-unit costs, making it a cost-effective option for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk Architecture & Construction Printing services ensure exceptional value while maintaining professional standards."
    }
];

const [pageTitle, setPageTitle] = useState('Ace Prints');  // Dynamic title state

  useEffect(() => {
    document.title = pageTitle; // Set the document title dynamically
  }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Architecture, Construction, and Engineering Printing Services"
  description="Professional printing of architecture plans, construction plans, and blueprints. Bulk 3D printing for construction and architecture projects."
  keywords="Architecture, Construction, & Engineering Prints,
Architecture & Construction Printing,
3D printing for construction and architecture,
Printing construction plans,
Printing of Architecture Plans,
Blueprint printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Architecture, Construction, & Engineering Printing Services</h1>
              <h2 className="text-muted">Professional printing solutions for construction plans, blueprints, and 3D models</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>In the architecture, construction, and engineering industries, precise and high-quality prints are essential for effective project execution. Printingy specialises in Architecture & Construction Printing services, offering customised solutions for printing construction plans, blueprint printing, and printing of architecture plans.</p>
          <p>Our services include 3D printing for construction and architecture, enabling detailed and accurate models to support design and planning processes. Whether for initial drafts, final plans, or 3D prototypes, we provide reliable and scalable solutions to meet your needs.</p>
          <p>With advanced printing technology and a commitment to accuracy, Printingy ensures your materials are produced with sharp details, vibrant colours, and durable finishes. We deliver quality and efficiency from bulk orders to specialised prints to support your project goals.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Architecture &amp; Construction Printing</h2>
                <h3 className="large-hed">High-quality, accurate, and scalable printing solutions for construction and engineering projects </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Precise printing of architecture plans for detailed designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customised 3D printing for construction and architecture models.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Reliable blueprint printing for clear and accurate project plans.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing construction plans for large-scale projects.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and eco-friendly materials for long-lasting results.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for sharp details and professional finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fast turnarounds and efficient order management systems.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by architects, engineers, and construction professionals nationwide.

                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/aecprinting.jpg" // Path relative to the public folder
                  alt="3D printing for construction and architecture projects"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
        title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Architecture Prints Delivered On Time </h2>
            <h3 className="small-hed">Focus on your designs while we manage your printing needs</h3>
            <p>At Printingy, we specialise in delivering exceptional Architecture & Construction Printing services tailored to your project requirements. Whether you need printing of architecture plans, blueprint printing, or 3D models, our advanced technology ensures precision and clarity in every print.</p>
            <p>Our streamlined processes and commitment to quality guarantee timely delivery for bulk orders, ensuring your materials are ready when needed. Partner with Printingy for reliable printing solutions that support your architectural, engineering, and construction projects.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default AcePrints;
